import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ListFilterComponent } from './list-filter.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { DateTimeRangeModule } from '../date-time-range';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [ListFilterComponent],
  imports: [
    CommonModule,
    FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatSelectModule,
    TranslateModule.forChild({}),
    IntrackFeatureModule,
    DateTimeRangeModule,
    SvgIconModule,
  ],
  exports: [ListFilterComponent],
})
export class ListFilterModule {}
